import {ValueObject} from '@s-ui/domain'

export class TagcloudListValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Array<TagcloudSeoValueObject>} deps.tagclouds
   **/
}
